var React = require('react');

function DiamondGreen (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M32.5608 0H6.44141L26.4785 16.7642L32.5608 0Z","fill":"#24CC85","key":0}),React.createElement("path",{"d":"M6.44034 0L0 10.8246L19.5 36L26.4775 16.7642L6.44034 0Z","fill":"#D4F9EC","key":1}),React.createElement("path",{"d":"M32.5597 0L26.4774 16.7642L19.5 36L39 10.8246L32.5597 0Z","fill":"#0E8F59","key":2})]);
}

DiamondGreen.defaultProps = {"width":"39","height":"36","viewBox":"0 0 39 36","fill":"none"};

module.exports = DiamondGreen;

DiamondGreen.default = DiamondGreen;
